export default __webpack_public_path__ + "static/media/flag-us.5f05c0c3.svg";